import { Sidebar, type SidebarProps } from 'primereact/sidebar'
import type { ReactNode } from 'react'

export interface DrawerWrapperProps extends SidebarProps {
  children: ReactNode
}

/**
 * A reusable wrapper for PrimeReact Sidebar that hides the default header
 * and allows for full control of the drawer content area.
 */
export const DrawerWrapper = ({ children, ...props }: DrawerWrapperProps) => {
  return (
    <Sidebar
      {...props}
      pt={{
        header: { className: 'hidden' },
        content: { className: 'p-0 h-full overflow-hidden' },
        ...props.pt,
      }}
    >
      {children}
    </Sidebar>
  )
}
